import React from "react";
import { LinearProgress, linearProgressClasses } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./stepFooter.css";

const StepFooter = ({
  currentStep,
  totalSteps,
  showBackButton = false,
  location,
  onNext, // Callback function from parent
  btnNextLabel = "Continue", // New parameter with a default value
  disabled = false, // New disabled parameter
}) => {
  const navigate = useNavigate();

  const progressValue = (currentStep / totalSteps) * 100;

  const handleContinue = () => {
    if (onNext) {
      onNext(); // Trigger the parent function (handleNext)
    }
    if (location) {
      navigate(location); // Navigate to the provided location
    }
  };

  return (
    <div className="step-footer">
      <div className="step-footer__progress">
        <LinearProgress
          variant="determinate"
          value={progressValue}
          sx={{
            height: 10,
            borderRadius: 5,
            [`&.${linearProgressClasses.colorPrimary}`]: {
              backgroundColor: "#F5F4F4",
            },
            [`& .${linearProgressClasses.bar}`]: {
              borderRadius: 5,
              backgroundColor: "#333333",
            },
          }}
        />
        <p className="step-footer-font">
          Step {currentStep} of {totalSteps}
        </p>
      </div>
      <div className="step-footer__actions">
        <button
          type="button"
          onClick={handleContinue}
          className="btn-next"
          disabled={disabled} // Disable the button if disabled prop is true
        >
          {btnNextLabel}
        </button>
      </div>
    </div>
  );
};

export default StepFooter;
